import { connect } from 'react-redux'
import { sagaActions } from 'store/sagas'
import notificationsSelector from './notificationsSelector'
import Notifications from './Notifications'
import {
  setUnreadOnly as setNotificationsUnreadOnly
} from 'store/redux/notifications'

export default connect(
  notificationsSelector,
  {
    fetchActivities: sagaActions.fetchNotifications,
    requestMarkAllNotificationsAsRead: sagaActions.requestMarkAllNotificationsAsRead,
    setNotificationsUnreadOnly,
  }
)(Notifications)
